import axios from 'axios';

//const currencyJS = require('currency.js');
import currencyJS from 'currency.js';
class PayPalService {
  public async verifyClientIdAsync(clientId: string) {
    const paypalSdkUrl = `https://www.paypal.com/sdk/js?client-id=`;

    try {
      const res = await axios.get(`${paypalSdkUrl}${clientId}`);

      return res.status === 200;
    } catch (error) {
      return false;
    }
  }

  public formatPrice(amount: number, currency: string) {
    function addSymbol(amount: number, currency: string) {
      switch (currency) {
        case 'AUD':
        case 'CAD':
        case 'NZD':
        case 'USD':
          return currencyJS(amount, { symbol: '$', separator: ',', decimal: '.', precision: 2 }).format();
        case 'EUR':
          return currencyJS(amount, { symbol: '€', separator: '.', decimal: ',', precision: 2 }).format();
        case 'GBP':
          return currencyJS(amount, { symbol: '£', separator: '.', decimal: ',', precision: 2 }).format();
        default:
          return `$${amount}`;
      }
    }

    return `${addSymbol(amount, currency)} ${currency || ''}`;
  }
}

export default new PayPalService();
